import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/free-solid-svg-icons'

import Card from './components/Card';
import styles from './styles.module.scss';
import { getConteudo } from '../../services/api-auto';
import ModalLoading from '../../components/ModalLoading';

import { useGetUser } from '../../hooks/useGetUser';

const Banner = props => {

    const history = useHistory();
    const [usuarios, setUsuarios] = useState([])
    const [buscar, setBuscar] = useState('')
    const [ativarBuscar, setAtivarBuscar] = useState(false)
    const [pagina, setPagina] = useState(1)
    const [maxPage, setMaxPage] = useState(1)
    const [modalLoading, setModalLoading] = useState(false);

    const verMais = (maxPage > pagina);
    

    const getUsuarios = async() => {
        setModalLoading(true)

        try{
            const info = await getConteudo(buscar);
            setUsuarios(info.data)
        }catch(e){

        }finally{
            setModalLoading(false)
        }
    }

    useEffect(() => {
        getUsuarios()
    },[])

    const user = useGetUser();

    return (
        <>
        {( user.perfilAcesso === 'Master' ) && (
            <>
                <div className={styles.wrapper}>
                    <div className={styles.title}>
                        Conteúdos
                    </div>
                    <div className={styles.buttonWrapper}>
                        <button className={`btnInvert ${styles.btAdd}`} onClick={() => {history.push('/conteudo/detalhes')}}>
                            Adicionar Conteúdo
                        </button>
                    </div>
                    <div className={styles.subTitle}>
                        Conteúdos cadastrados
                    </div>
                    <div className={styles.buscar}>
                        <FormControl>
                            <TextField  type="text"  size="small"
                                onChange={(e) => {setBuscar(e.target.value)}}
                                label="Faça sua busca"
                                value={buscar}
                                variant="filled"
                                multiline
                                className="customFilledInput"
                                onKeyDown= {
                                    (e) => {
                                        if (e.key === 'Enter') {
                                            getUsuarios();
                                            e.preventDefault();
                                        }
                                    }
                                }
                                InputProps={{endAdornment: (
                                    <button onClick={getUsuarios} className={styles.searcButton}>
                                        <FontAwesomeIcon icon={faSearch}/>
                                    </button>
                                )}}
                            />
                        </FormControl>
                    </div>
                    <div className={styles.acoesWrapper}>
                        {
                            Boolean(usuarios.length) ?
                                usuarios.map(
                                    (usuario) => {return (<Card usuario={usuario} key={usuario.id} setLoading={setModalLoading} update={getUsuarios}/>)}
                                )
                            :
                            (
                                !modalLoading &&
                                (
                                    <div>
                                        Nenhum registro encontrado
                                    </div>
                                )
                            )
                        }
                    </div>
                    <ModalLoading
                        open={modalLoading} 
                        size="lg"
                    />
                </div>
            </>
        )}

        </>
    );
  
}

export default Banner;